import {TextStyleAlign} from "pixi.js";

export default class AlignUtil
{
    public static readonly CENTER:TextStyleAlign = "center";
    public static readonly INNER:number = 0;
    public static readonly LEFT:TextStyleAlign = "left";
    public static readonly MIDDLE:number = 1;
    public static readonly OUTER:number = .5;
    public static readonly RIGHT:TextStyleAlign = "right";
}